import TextareaBox from '../../../../common/interactive/TextareaBox'
import Button from '../../../../common/Button'
import { markProcodocsRequestMessagesAsRead, procodocsRequestSendMessage } from '../../../../../lib/fetchApi'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { notificationActions } from '../../../../../store/notifications'
import { useDispatch } from 'react-redux'
import { caseActions } from '../../../../../store/case'


export default function RequestSendMessage({request, refreshRequests, setRefreshMessagesFlag}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const caseId = useSelector(state => state.case.activeCase.case.id)
    const case_attorney_id = useSelector(state => state.case.activeCase.attorneys.find(attorney => attorney.is_managing_attorney)?.id)
    const selectedProcoDocsAttorney = useSelector(state => state.attorney.selectedProcoDocsAttorney)

    const [isLoading, setIsLoading] = useState(false)
    async function submitHandler(event) {
        event.preventDefault()
        setIsLoading(true)
        try {
            const fd = new FormData(event.target)
            const data = Object.fromEntries(fd.entries())
   
            let sendMessage = await procodocsRequestSendMessage(userToken, caseId, request.id, data)
            if (sendMessage?.errorMessage) {
                dispatch(notificationActions.setError(sendMessage))
            } else {
                await markProcodocsRequestMessagesAsRead(userToken, caseId, request.id)
                dispatch(caseActions.markRequestAsRead(request.id))
                dispatch(caseActions.markRequestMessagesAsReadInAttorney({
                    case_attorney_id: selectedProcoDocsAttorney ? selectedProcoDocsAttorney : case_attorney_id
                }))
                if (request?.is_resolved && refreshRequests) {
                    refreshRequests()
                } else if (setRefreshMessagesFlag) {
                    setRefreshMessagesFlag(true)
                }
                event.target.reset()
            }
        } finally {
            setIsLoading(false)
        }
    }

    return <div>
        <form onSubmit={submitHandler}>
            <div className="row">
                <TextareaBox label="Message" name="message" required={true} placeholder="" />
            </div>
            <div className="row">
                <Button title="Send" btnStyle="btn_small" type={'submit'} isLoading={isLoading}>Send</Button>
            </div>
        </form>
    </div>
}